<div id="page-not-found-container">
    <h1 i18n="404 not found|@@notFound">404 Page Not Found.</h1>
    <p class="inline" i18n="page does not exist |@@notExist">The requested page does not exist.</p>
    <button type="button" class="individual-button responsive-font-size home-button"  mat-button i18n="home |@@home" (click)="backToHome()">
        <mat-icon>home</mat-icon>
        <span> Home </span>
    </button>
</div>

